module.exports = __webpack_public_path__ + "img/index_new_bg.a798602d.png";